import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import uploadIcon from "./img/upload.svg";
import "./FileUpload.scss";

const FileUpload = ({ onFileSelect, uniqueId }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
    // if (onFileSelect) {
    //   onFileSelect(files);
    // }
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    setSelectedFiles(files);
    // if (onFileSelect) {
    //   onFileSelect(files);
    // }
  };

  const uploadFile = () => {
    onFileSelect(selectedFiles, "UPLOAD")
  }

  return (
    <div className="file-upload-container">
      <div 
        className="file-drop-zone d-flex flex-column"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <img src={uploadIcon} alt="Upload Icon" className="upload-icon" />
        <Form.Control type="file" multiple onChange={handleFileChange} className="d-none" id={`fileInput-${uniqueId}`} />
        <label htmlFor={`fileInput-${uniqueId}`} className="uploadLink mt-2">Drag & drop files or Click here to Upload Files</label>
      </div>

      {selectedFiles.length > 0 && (
        <div className="file-list">
          <h6>Selected Files:</h6>
          <ul className="list-group">
            {selectedFiles.map((file, index) => (
              <li key={index} className="list-group-item">
                {file.name} ({(file.size / 1024).toFixed(2)} KB)
              </li>
            ))}
          </ul>
        </div>
      )}

      {selectedFiles.length === 2 && (
        <Button variant="primary" className="upload-btn" onClick={uploadFile}>Upload</Button>
      )}
    </div>
  );
};

export default FileUpload;
